import { useEffect, useState, useRef } from 'react';
import { successAlert, warningAlert, errorAlert } from 'ui-component/Toasts';

// material-ui
import { Box, Button, Grid, Typography, TextField, FormControl, Select, MenuItem, Autocomplete } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import { axiosInstance } from 'utils/axios';
import dayjs from 'dayjs';
import useFetchData from 'hooks/useFetchData';
import CustomerTable from './components/CustomerTable';
import * as XLSX from 'xlsx';
import { fontSize } from '@mui/system';
import { useTranslation } from "react-i18next";

const Customer = () => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);
    const buttonRef = useRef(null);
    const triggeredByKeyRef = useRef(false);

    const [customers, setCustomers] = useState([]);
    const [filterCustomerFrom, setFilterCustomerFrom] = useState(dayjs().subtract(7, 'days'));
    const [filterCustomerTo, setFilterCustomerTo] = useState(dayjs());
    const [filterCustomerName, setFilterCustomerName] = useState('');

    const [filterCustomerLoginUserName, setFilterCustomerLoginUserName] = useState('');
    const [filterCustomerLoginUserNameInputText, setFilterCustomerLoginUserNameInputText] = useState('');
    const [filterCustomerLoginUserNameHighlightedOption, setFilterCustomerLoginUserNameHighlightedOption] = useState(null);

    const [filterCustomerRecommend, setFilterCustomerRecommend] = useState('');
    const [filterCustomerStatus, setFilterCustomerStatus] = useState('');
    const [filterCustomerUserName, setFilterCustomerUserName] = useState('');

    const [filterCustomerNumberCode, setFilterCustomerNumberCode] = useState('');
    const [filterCustomerNumberCodeInputText, setFilterCustomerNumberCodeInputText] = useState('');
    const [filterCustomerNumberCodeHighlightedOption, setFilterCustomerNumberCodeHighlightedOption] = useState('');

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const [filterIsRecommend, setFilterIsRecommend] = useState('');
    const [filterIsDeposited, setFilterIsDeposited] = useState('');
    const [filterIsRepeatCustomer, setFilterIsRepeatCustomer] = useState('');
    const [filterPhoneNumber, setFilterPhoneNumber] = useState('');
    const [filterBankAccountNumber, setFilterBankAccountNumber] = useState('');
    const [filterIsAutoSubscribeCustomer, setFilterIsAutoSubscribeCustomer] = useState('');
    const [filterIPAddress, setFilterIPAddress] = useState('');


    const [fetchCustomerLoading, setFetchCustomerLoading] = useState(false);
    const fetchCustomers = async () => {
        setFilterBtnDisabled(true);

        if (triggeredByKeyRef.current) {
            triggeredByKeyRef.current = false; // Reset the flag
            return;
        }

        if (!filterCustomerFrom.isValid() || !filterCustomerTo.isValid()) {
            warningAlert('Please fill up all required fields.');
            return;
        }
        let fetchCustomersURL = `/CustomerDetail/All?createdDateFrom=${filterCustomerFrom.format(
            'YYYY-MM-DD'
        )}&createdDateTo=${filterCustomerTo.format('YYYY-MM-DD')}`;

        if (filterCustomerName !== '') {
            fetchCustomersURL += `&name=${filterCustomerName}`;
        }
        if (filterCustomerRecommend !== '') {
            fetchCustomersURL += `&recommendBy=${filterCustomerRecommend}`;
        }
        if (filterCustomerStatus !== '') {
            fetchCustomersURL += `&customerStatusID=${filterCustomerStatus}`;
        }
        if (filterCustomerUserName !== '') {
            fetchCustomersURL += `&userName=${filterCustomerUserName}`;
        }
        // if (filterCustomerNumberCodeHighlightedOption !== '' || filterCustomerNumberCodeInputText !== '') {
        //     fetchCustomersURL += `&numberCode=${filterCustomerNumberCodeHighlightedOption || filterCustomerNumberCodeInputText}`;
        // }
        // if (filterCustomerLoginUserNameHighlightedOption !== '' || filterCustomerLoginUserNameInputText !== '') {
        //     fetchCustomersURL += `&loginUserName=${filterCustomerLoginUserNameHighlightedOption || filterCustomerLoginUserNameInputText}`;
        // }
        if (filterCustomerNumberCode !== '') {
            fetchCustomersURL += `&numberCode=${filterCustomerNumberCode}`;
        }
        if (filterCustomerLoginUserName !== '') {
            fetchCustomersURL += `&loginUserName=${filterCustomerLoginUserName}`;
        }
        if (filterIsRecommend !== '') {
            fetchCustomersURL += `&isRecommendBy=${filterIsRecommend}`;
        }
        if (filterIsDeposited !== '') {
            fetchCustomersURL += `&isDeposited=${filterIsDeposited}`;
        }
        if (filterIsRepeatCustomer !== '') {
            fetchCustomersURL += `&isRepeatCustomer=${filterIsRepeatCustomer}`;
        }
        if (filterPhoneNumber !== '') {
            fetchCustomersURL += `&phoneNumber=${filterPhoneNumber}`;
        }
        if (filterBankAccountNumber !== '') {
            fetchCustomersURL += `&bankAccount=${filterBankAccountNumber}`;
        }
        if (filterIsAutoSubscribeCustomer !== '') {
            fetchCustomersURL += `&isAutoSubscribe=${filterIsAutoSubscribeCustomer}`;
        }
        if (filterIPAddress !== '') {
            fetchCustomersURL += `&ipAddress=${filterIPAddress}`;
        }

        setFetchCustomerLoading(true);
        try {
            const res = await axiosInstance.get(fetchCustomersURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCustomers(res.data);
                // setCustomers((customers) => [...customers, ...res.data]);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchCustomerLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    // updated
    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterCustomerFrom.isValid() || !filterCustomerTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }

        // Construct the sales URL with the new parameters
        let customersUrl = `/CustomerDetail/All?createdDateFrom=${filterCustomerFrom.format(
            'YYYY-MM-DD'
        )}&createdDateTo=${filterCustomerTo.format('YYYY-MM-DD')}`;
        // createdDateTo=${filterSalesTo.format('YYYY-MM-DD')}&pageIndex=${page}&pageSize=${rowsPerPage}`;

        if (filterCustomerName !== '') {
            customersUrl += `&name=${filterCustomerName}`;
        }
        if (filterCustomerRecommend !== '') {
            customersUrl += `&recommendBy=${filterCustomerRecommend}`;
        }
        if (filterCustomerStatus !== '') {
            customersUrl += `&customerStatusID=${filterCustomerStatus}`;
        }
        if (filterCustomerUserName !== '') {
            customersUrl += `&userName=${filterCustomerUserName}`;
        }
        if (filterCustomerNumberCode !== '') {
            customersUrl += `&numberCode=${filterCustomerNumberCode}`;
        }
        if (filterCustomerLoginUserName !== '') {
            customersUrl += `&loginUserName=${filterCustomerLoginUserName}`;
        }
        if (filterIsRecommend !== '') {
            customersUrl += `&isRecommendBy=${filterIsRecommend}`;
        }
        if (filterIsDeposited !== '') {
            customersUrl += `&isDeposited=${filterIsDeposited}`;
        }
        if (filterIsRepeatCustomer !== '') {
            customersUrl += `&isRepeatCustomer=${filterIsRepeatCustomer}`;
        }
        if (filterPhoneNumber !== '') {
            customersUrl += `&phoneNumber=${filterPhoneNumber}`;
        }
        if (filterBankAccountNumber !== '') {
            customersUrl += `&bankAccount=${filterBankAccountNumber}`;
        }
        if (filterIsAutoSubscribeCustomer !== '') {
            customersUrl += `&isAutoSubscribe=${filterIsAutoSubscribeCustomer}`;
        }

        try {
            const res = await axiosInstance.get(customersUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `Customer_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    // updated end

    // const [customerStatus, setCustomerStatus] = useState([]);
    const { data: customerStatus } = useFetchData('/CustomerStatus');

    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    // const { data: customerNameOptions } = useFetchData('/Customer/Names');
    
    const { data: loginUsernameOptions } = useFetchData('/Customer/LoginUserNames');
    const { data: numberCodeOptions } = useFetchData('/Customer/NumberCodes');

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const [customerTasklistStatusList, setCustomerTasklistStatusList] = useState([]);
    // const fetchCustomerTasklistStatus = async () => {
    //     try {
    //         const res = await axiosInstance.get('/CustomerTasklistStatus/All', {
    //             headers: {
    //                 Authorization: `Bearer ${token}`
    //             }
    //         });

    //         if (res.status === 200) {
    //             setCustomerTasklistStatusList(res.data);
    //         } else {
    //             errorAlert('Something went wrong.');
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const handleFilterIsDeposited = async () => {
        console.log('filterIsDeposited', filterIsDeposited);

        setFilterIsDeposited(!filterIsDeposited);
        fetchCustomers();
    };

    useEffect(() => {
        Promise.all([fetchCustomers()]).catch((error) => {
            console.error('An error occurred:', error);
        });
    }, []);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            buttonRef.current.click(); // Simulate button click
        }
    };

    // useEffect(() => {
    //     fetchCustomers();
    //     const interval = setInterval(() => {
    //         fetchCustomers();
    //     }, 1000 * 2);

    //     return () => {
    //         clearInterval(interval);
    //     };
    // }, []);

    return (
        <Grid container item xs={12} onKeyDown={handleKeyDown} tabIndex={0}>
            {/* <CreateCustomerModal /> */}
            {/* {isUserAllowEdit && 
                
            } */}
            <Box sx={{ display: 'flex', justifyContent: 'end', gap: '10px', width: '100%', alignItems: 'center' }}>
                <Link to="/customer/createCustomer">
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                    >
                        {t("customer.createCustomer")}
                    </Button>
                </Link>
            </Box>

            {/* Filter component */}
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>{t("customer.createdDate")} :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{fontSize: '14px'}}>
                            <DatePicker
                                value={filterCustomerFrom}
                                slotProps={{
                                    textField: {
                                        error: false,
                                        size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                        sx: {
                                          '& .MuiInputBase-root': {
                                            fontSize: '13px',      // font size of the input
                                            padding: '4px 8px',    // optional: reduce input padding
                                            minHeight: '36px',     // optional: control input height
                                          },
                                          '& .MuiInputBase-input': {
                                            fontSize: '13px',      // font size inside input
                                            padding: '8.5px 14px', // adjust input padding if needed
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: '13px',      // label font size
                                          },
                                        },
                                    }
                                }}
                                onChange={(newValue) => setFilterCustomerFrom(newValue)}
                            />
                        </LocalizationProvider>
                        -
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterCustomerTo}
                                slotProps={{
                                    textField: {
                                        error: false,
                                        size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                        sx: {
                                          '& .MuiInputBase-root': {
                                            fontSize: '13px',      // font size of the input
                                            padding: '4px 8px',    // optional: reduce input padding
                                            minHeight: '36px',     // optional: control input height
                                          },
                                          '& .MuiInputBase-input': {
                                            fontSize: '13px',      // font size inside input
                                            padding: '8.5px 14px', // adjust input padding if needed
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: '13px',      // label font size
                                          },
                                        },
                                    }
                                }}
                                onChange={(newValue) => setFilterCustomerTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        -
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterCustomerTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterCustomerTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid> */}
                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("customer.loginUserName")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterCustomerLoginUserName}
                            onChange={(e) => setFilterCustomerLoginUserName(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                        {/* <Autocomplete
                            freeSolo
                            options={loginUsernameOptions}
                            value={filterCustomerLoginUserName}
                            inputValue={filterCustomerLoginUserNameInputText}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'clear' || newInputValue === '') {
                                    // User cleared the input
                                    setFilterCustomerLoginUserNameInputText('');
                                    setFilterCustomerLoginUserName('');
                                    setFilterCustomerLoginUserNameHighlightedOption(null);
                                } else {
                                    setFilterCustomerLoginUserNameInputText(newInputValue);
                                }
                            }}
                            onHighlightChange={(event, option) => {
                                setFilterCustomerLoginUserNameHighlightedOption(option);
                            }}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setFilterCustomerLoginUserName(newValue);
                                    setFilterCustomerLoginUserNameInputText(newValue);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();

                                    // 🟡 Set flag so button click doesn't double-fire
                                    triggeredByKeyRef.current = true;

                                    // Trigger the button click manually
                                    if (buttonRef.current) {
                                        buttonRef.current.click();
                                    }
                                }
                            }}
                            sx={{ width: 170 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    sx={{
                                        '& .MuiInputBase-root': {
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiAutocomplete-input': {
                                        fontSize: '13px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiInputLabel-root': {
                                        fontSize: '13px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option === value}
                            disableClearable
                        /> */}
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("customer.code")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterCustomerNumberCode}
                            onChange={(e) => setFilterCustomerNumberCode(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                        {/* <Autocomplete
                            freeSolo
                            options={numberCodeOptions}
                            value={filterCustomerNumberCode}
                            inputValue={filterCustomerNumberCodeInputText}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'clear' || newInputValue === '') {
                                    // User cleared the input
                                    setFilterCustomerNumberCodeInputText('');
                                    setFilterCustomerNumberCode('');
                                    setFilterCustomerNumberCodeHighlightedOption(null);
                                } else {
                                    setFilterCustomerNumberCodeInputText(newInputValue);
                                }
                            }}
                            onHighlightChange={(event, option) => {
                                setFilterCustomerNumberCodeHighlightedOption(option);
                            }}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setFilterCustomerNumberCode(newValue);
                                    setFilterCustomerNumberCodeInputText(newValue);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();

                                    // 🟡 Set flag so button click doesn't double-fire
                                    triggeredByKeyRef.current = true;

                                    // Trigger the button click manually
                                    if (buttonRef.current) {
                                        buttonRef.current.click();
                                    }
                                }
                            }}
                            sx={{ width: 170 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    sx={{
                                        '& .MuiInputBase-root': {
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiAutocomplete-input': {
                                        fontSize: '13px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiInputLabel-root': {
                                        fontSize: '13px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option === value}
                            disableClearable
                        /> */}
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("customer.ipAddress")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterIPAddress}
                            onChange={(e) => setFilterIPAddress(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("customer.phoneNumber")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterPhoneNumber}
                            onChange={(e) => setFilterPhoneNumber(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("customer.customerStatus")} :
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                value={filterCustomerStatus}
                                onChange={(e) => setFilterCustomerStatus(e.target.value)}
                                sx={{
                                    fontSize: '13px',
                                    minHeight: '36px',
                                    '& .MuiSelect-select': {
                                        fontSize: '13px',
                                        padding: '10px 14px',
                                    },
                                    '& .MuiInputBase-root': {
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        padding: '10px 14px',
                                    },
                                }}
                            >
                                <MenuItem value="">{t("customer.pleaseSelectCustomerStatus")}</MenuItem>
                                {customerStatus.map((item, index) => (
                                    <MenuItem value={item.id} key={index}>
                                        {item.name === 'Active' ? t("customer.activated") : item.name === 'Inactive' ? t("customer.deactivated") : ''}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("customer.onlineOffline")} :
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                value={filterIsDeposited}
                                onChange={(e) => setFilterIsDeposited(e.target.value)}
                                sx={{
                                    fontSize: '13px',
                                    minHeight: '36px',
                                    '& .MuiSelect-select': {
                                        fontSize: '13px',
                                        padding: '10px 14px',
                                    },
                                    '& .MuiInputBase-root': {
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        padding: '10px 14px',
                                    },
                                }}
                            >
                                <MenuItem value="" style={{fontSize: '14px'}}>{t("customer.all")}</MenuItem>
                                <MenuItem value="true">{t("customer.online")}</MenuItem>
                                <MenuItem value="false">{t("customer.offline")}</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>

                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Recommend By :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterCustomerRecommend}
                            onChange={(e) => setFilterCustomerRecommend(e.target.value)}
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer Status :
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                value={filterCustomerStatus}
                                onChange={(e) => setFilterCustomerStatus(e.target.value)}
                                // sx={{width:"100%"}}
                            >
                                <MenuItem value="">Select Status</MenuItem>
                                {customerStatus.map((item, index) => (
                                    <MenuItem value={item.id} key={index}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Created By :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterCustomerUserName}
                            onChange={(e) => setFilterCustomerUserName(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer ID :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterCustomerNumberCode}
                            onChange={(e) => setFilterCustomerNumberCode(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Recommend :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterIsRecommend}
                            onChange={(e) => setFilterIsRecommend(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Deposited :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterIsDeposited}
                            onChange={(e) => setFilterIsDeposited(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Repeat Customer :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterIsRepeatCustomer}
                            onChange={(e) => setFilterIsRepeatCustomer(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Phone Number :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterPhoneNumber}
                            onChange={(e) => setFilterPhoneNumber(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Bank Account Number :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterBankAccountNumber}
                            onChange={(e) => setFilterBankAccountNumber(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Auto Subscribe :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterIsAutoSubscribeCustomer}
                            onChange={(e) => setFilterIsAutoSubscribeCustomer(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid> */}
            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    gap: '15px',
                    width: '50%',
                    marginLeft: 'auto'
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => fetchCustomers()}
                    disabled={filterBtnDisabled}
                    ref={buttonRef}
                >
                    {t("customer.filter")}
                </Button>
                {/* Filter component end */}
                
                {/* <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => exportDataAsXlsx()}
                    disabled={filterBtnDisabled}
                >
                    Export Data
                </Button> */}
            </Box>
            {/* Filter component end */}

            <CustomerTable
                customers={customers}
                fetchCustomerLoading={fetchCustomerLoading}
                customerTasklistStatusList={customerTasklistStatusList}
                customerStatus={customerStatus}
                fetchCustomers={fetchCustomers}
                loginUsernameOptions={loginUsernameOptions}
            />
        </Grid>
    );
};

export default Customer;
